import { viemChains } from '@vaultsfyi/common'

export function getNativeCurrency(network: string) {
  const symbol = viemChains[network as keyof typeof viemChains]?.nativeCurrency?.symbol.toLowerCase()
  if (!symbol) {
    throw new Error(`Native currency symbol not found for ${network}`)
  }
  return symbol
}
